/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock, WithPrivilegedToken } from '@gh/core-data';

import { UserStatus } from './user-status.enum';

export const UserAllowAccess = createEnum('USER_ALLOW_ACCESS', {
  OwnLeads: 'OWN_LEADS',
  SalespersonLeads: 'SALESPERSON_LEADS',
  AllLeads: 'ALL_LEADS',
});

export type UserAllowAccess = EnumSet<typeof UserAllowAccess>;

export type UserDetailsContactDto = {
  id: ID;
  name: string;
  firstName?: string;
  lastName?: string;
};

export type UserDetailsSalesPersonDto = {
  userId: string;
  userName: string;
  userEmail?: string;
  systemRoles: Hash<boolean>;
  officeRole: any;
  status: UserStatus;
  statusValue: UserStatus;
};

export type UserDataToTransfer = {
  userId: string;
  userName: string;
};

export type UserValidateLoginDto = {
  valid: boolean;
  transferred?: boolean;
};

export type UserDetailsFilterDto = {
  name?: string;
  id?: ID;
  autocomplete?: boolean;
  showInactive?: boolean;
};

export type UserPositionDto = {
  code: string;
  itemCode: string;
  localization: string;
};

export type UserDetailsDto = WithOptimisticLock<WithPrivilegedToken<{
  status: UserStatus;
  userEmail: string;
  systemRoles: Hash<boolean>;
  userId?: ID;
  transfer?: string;
  contact?: UserDetailsContactDto;
  role?: number;
  position?: UserPositionDto;
  confirmations?: any;
  allowAccessToLeads?: UserAllowAccess;
  leadsOf?: ID[];
  intranetGuid?: ID;
  userToReassignLeadsTo?: string;
  allowAccessToMultipleOffices: boolean;
  sendEmailsFrom?: any;
  publishToWeb: boolean;
  userDataToTransfer?: string;
}>>;

export type UserDetailsShortDto = {
  userId: ID;
  userName: string;
};

export type UserAssignedRoleDto = {
  roleAssigned: boolean;
};

export type UserDetailsVerifyDto = WithOptimisticLock<WithPrivilegedToken<{
  userId: ID;
  intranetUser: string;
  intranetPassword: string;
}>>;

export type UserDetailsIntranetDto = {
  intranetGuid: ID;
};
